import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaDocumentosLayoutsbancariosPendientesLayout', {
    template: template,
    controller: NominaDocumentosLayoutsbancariosPendientesLayoutComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      idTipoPago: '<',
      idBanco: '<',
      idCuenta: '<',
      fechaPago: '<',
      interbancario: '<',
      banco: '<',
      numeroCuenta: '<',
      moneda: '<',
      onClose: '&',
      onChange: '&',
    },
  })

function NominaDocumentosLayoutsbancariosPendientesLayoutComponent($file, $q, $zip, NominaDocumentosLayoutsbancarios, NominaDocumentosLayoutsbancariosPendientesLayout) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.aceptar = aceptar
  $ctrl.cerrar = cerrar
  $ctrl.generando = false
  $ctrl.descargar = descargar
  $ctrl.error = null
  $ctrl.seleccionar = seleccionar
  $ctrl.total = undefined
  $ctrl.config = {consecutivo: 1, dividir: false, dividirCantidad: 500}

  function $onInit() {
    $ctrl.promise = NominaDocumentosLayoutsbancariosPendientesLayout.get($ctrl.idProyecto, $ctrl.idNomina, $ctrl.idTipoPago, $ctrl.idBanco, $ctrl.idCuenta, $ctrl.fechaPago, $ctrl.interbancario)
      .then(function (response) {
        $ctrl.data = response.data
          .map(function (item) {
            item.$$valido = !!item.banco_cuenta

            return item
          })

        $ctrl.invalidos = $ctrl.data.reduce(function (total, item) {
          return total + (item.$$valido ? 0 : 1)
        }, 0)
      })
  }

  function aceptar() {
    $ctrl.generando = true
    $ctrl.error = null

    let data = $ctrl.seleccionados.map(function (item) {
      return item.id_pago
    })

    let chunks = $ctrl.config.dividir
      ? Array(Math.ceil(data.length / $ctrl.config.dividirCantidad))
        .fill()
        .map(function (_, i) {
          return data.slice(i * $ctrl.config.dividirCantidad, i * $ctrl.config.dividirCantidad + $ctrl.config.dividirCantidad)
        })
      : [data]

    $q.all(chunks.map(function (ids, index) {
        let config = {}

        if ($ctrl.idBanco === '007')
          config.consecutivo = ($ctrl.config.consecutivo || 1) + index

        return generar(ids, config)
      }))
      .then(function (layouts) {
        if (layouts.length > 1) {
          return $zip()
            .then(function (zip) {
              let filename = $ctrl.banco + ' ' + $ctrl.numeroCuenta + ' ' + $ctrl.moneda + ' - ' + $ctrl.idNomina + '.zip'

              layouts.reduce(function (zip, layout, index) {
                return zip.file(layout.filename.replace('.txt', '(' + (index + 1) + ').txt'), layout.content)
              }, zip)

              $ctrl.archivo = {
                save: function () {
                  zip.generateAsync({
                    type: 'blob',
                    compression: 'DEFLATE',
                    mimeType: 'application/zip',
                  }).then(function (content) {
                    $file.saveAs(content, filename)
                  })
                },
              }
            })
            .finally(function () {
              $ctrl.onChange()
            })
        } else {
          $ctrl.archivo = layouts[0]

          $ctrl.onChange()
        }
      })
      .catch(function (response) {
        $ctrl.error = (response && response.data) || 'Se ha generado un error'
      })
      .finally(function () {
        $ctrl.generando = false
      })
  }

  function generar(ids, config) {
    return NominaDocumentosLayoutsbancarios.post($ctrl.idProyecto, $ctrl.idNomina, $ctrl.idTipoPago, $ctrl.idBanco, $ctrl.idCuenta, $ctrl.fechaPago, $ctrl.interbancario, config, ids)
      .then(function (response) {
        return response.data
      })
  }

  function cerrar() {
    $ctrl.onClose()
  }

  function descargar() {
    $ctrl.archivo.save()
  }

  function seleccionar(data) {
    $ctrl.seleccionados = data.filter((item) => item.$$seleccionado)

    $ctrl.total = $ctrl.seleccionados.reduce(function (total, item) {
      return total + item.importe
    }, 0)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsbancarios/pendientes/layout/component.js